// ─── theme.js ─────────────────────────────────────────────────────────────────
// Single source of truth for the colour palette and font names.
// Import as:  import { C, LIGHT, FONTS } from "./theme";
// For components: import { useTheme } from "./theme"; then const C = useTheme();

import { createContext, useContext } from "react";

export const C = {
  bg:          "#0A0E1A",
  surface:     "#111827",
  surfaceAlt:  "#161D2E",
  border:      "#1E2D45",
  borderLight: "#243550",
  accent:      "#00D4FF",
  accentDim:   "#0099BB",
  accentGlow:  "rgba(0,212,255,0.12)",
  danger:      "#FF4444",
  warn:        "#FF8C00",
  success:     "#00E676",
  gold:        "#F0B429",
  purple:      "#A78BFA",
  orange:      "#FF6B35",
  text:        "#E8EDF5",
  textMid:     "#8A9BB5",
  textDim:     "#4A5870",
};

export const LIGHT = {
  bg:          "#F8FAFC",
  surface:     "#FFFFFF",
  surfaceAlt:  "#F1F5FB",
  border:      "#CBD5E6",
  borderLight: "#B4C6DD",
  accent:      "#0072B1",
  accentDim:   "#004A80",
  accentGlow:  "rgba(0,114,177,0.12)",
  danger:      "#DC2626",
  warn:        "#D97706",
  success:     "#059669",
  gold:        "#B45309",
  purple:      "#7C3AED",
  orange:      "#EA580C",
  text:        "#0F172A",
  textMid:     "#334155",
  textDim:     "#64748B",
};

export const FONTS = {
  display: "'Syne', sans-serif",
  mono:    "'DM Mono', monospace",
};

export const ThemeContext = createContext(C);
export function useTheme() { return useContext(ThemeContext); }